export const DESKTOP_ID = 28514;
export const MOBILE_ID = 28515;
export const SCRIPT_PATH = `//rb.infox.sg/infox/`;
